/**
 * Regalo automático: Personal Mixer gratis por compras sobre $250.000 CLP
 * El descuento "Regalo Personal Mixer - Compras sobre $250.000" (automático, 100% off)
 * ya deja el producto en $0 cuando corresponde. Este script se encarga de
 * agregarlo/quitarlo del carrito automáticamente según el subtotal.
 */
(function () {
  var GIFT_VARIANT_ID = 52889188565301; // Personal Mixer - SUP-ACC-PERSMIX
  var THRESHOLD = 25000000; // $250.000 CLP (cart.js expresa los montos x100)
  var isChecking = false;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function subtotalExcludingGift(cart) {
    var giftLine = findGiftLine(cart);
    var giftTotal = giftLine ? giftLine.original_line_price : 0;
    return cart.items_subtotal_price - giftTotal;
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { Regalo: 'Incluido por compra sobre $250.000' },
          },
        ],
      }),
    });
  }

  function setGiftQuantity(quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: quantity }),
    });
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (window.PubSub && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.PubSub.publish(window.PUB_SUB_EVENTS.cartUpdate, {});
    }
  }

  function isCartPage() {
    return window.location.pathname.indexOf('/cart') === 0;
  }

  function checkAndSync() {
    if (isChecking) return;
    isChecking = true;
    var changed = false;
    getCart()
      .then(function (cart) {
        var giftLine = findGiftLine(cart);
        var subtotal = subtotalExcludingGift(cart);
        var qualifies = subtotal >= THRESHOLD;

        if (qualifies && !giftLine) {
          changed = true;
          return addGift();
        } else if (!qualifies && giftLine) {
          changed = true;
          return setGiftQuantity(0);
        } else if (qualifies && giftLine && giftLine.quantity !== 1) {
          changed = true;
          return setGiftQuantity(1);
        }
      })
      .catch(function (err) {
        console.error('[Regalo Mixer]', err);
      })
      .finally(function () {
        isChecking = false;
        if (changed && isCartPage()) {
          // Recargamos la página del carrito para que el precio/total se vea correcto de inmediato.
          window.location.reload();
        } else {
          refreshCartUI();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', checkAndSync);

  // Red de seguridad: revisa periódicamente por si el tema agrega/quita
  // productos del carrito sin pasar por fetch (drawers de terceros, etc.)
  setInterval(checkAndSync, 4000);

  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] && args[0].url ? args[0].url : args[0];
    var isCartMutation =
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1);

    var promise = originalFetch.apply(this, args);

    if (isCartMutation) {
      promise.then(function () {
        setTimeout(checkAndSync, 300);
      });
    }

    return promise;
  };
})();
